import {
  Container,
  Grid2,
  Stack,
  Typography,
  Box,
  Rating,
  ButtonBase,
} from "@mui/material";
import React from "react";
import AppReviewDisplayCard, {
  IAppReview,
} from "../ReviewShowcase/AppReviewDisplayCard";
import CharacterOnGlobe from "../../../assets/svgs/characterOnGlobe.svg";
import StarOutlineFilled from "../../icons/StarOutlineFilled";
import StarOutlineEmpty from "../../icons/StarOutlineEmpty";
import { AppStoreRating, GooglePlayRating } from "../../../constants/text";
import COLORS from "../../../constants/colors";

interface Props {
  bgcolor?: string;
  reviews: IAppReview[];
}

const StaticFourPointFiveStar = () => (
  <Rating
    precision={0.5}
    readOnly
    value={4.5}
    size="medium"
    icon={
      <Box pr="4px">
        <StarOutlineFilled fontSize="inherit" />
      </Box>
    }
    emptyIcon={
      <Box pr="4px">
        <StarOutlineEmpty fontSize="inherit" />
      </Box>
    }
  />
);
const AbstractStackWithFigure = () => {
  return (
    <Grid2
      container
      direction={{ md: "row", xs: "column" }}
      justifyContent="center"
      alignItems="center"
    >
    <Grid2 size={{ xs: 12, md: 6 }}>
        <Stack
          display="flex"
          justifyContent="center"
          sx={{
            paddingBottom: { xs: "24px", md: "0px" },
          }}
        >
          <CharacterOnGlobe width="100%" height="320px" />
        </Stack>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 6 }}>
        <Stack sx={{ maxWidth: "505px" }}>
          <Stack spacing="24px" alignItems={{ md: "flex-start", xs: "center" }}>
            <Stack pt={{ xs: "20px" }} spacing="25px">
              <Typography
                variant="h2"
                fontFamily="Erlik"
                color={COLORS.BLUE[100]}
              >
                FORNØYDE BRUKERE
              </Typography>
              <Typography
                variant="body"
                color={COLORS.DARK_BLUE[100]}
                maxWidth="440px"
              >
                Vi er et lite, norsk selskap med ett mål – å gjøre vanlige folk
                til sjef i egen økonomi. Det får vi fornøyde brukere av.
              </Typography>
              <Stack
                direction={{ md: "row", xs: "column" }}
                spacing={{ md: "34px", xs: "20px" }}
                paddingRight={{ md: "0px", xs: "0px" }}
              >
                <ButtonBase
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    borderRadius: "20px",
                  }}
                  target="_blank"
                  href="https://apps.apple.com/no/app/horde-sjef-i-egen-%C3%B8konomi/id1471960734?platform=iphone"
                >
                  <Typography component="u" color="primary">
                    App Store
                  </Typography>
                  <Typography component="u" color="primary">
                    {AppStoreRating}
                  </Typography>
                  <StaticFourPointFiveStar />
                </ButtonBase>
                <ButtonBase
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    borderRadius: "20px",
                  }}
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.horde&hl=no"
                >
                  <Typography component="u" color="primary">
                    Google Play
                  </Typography>
                  <Typography component="u" color="primary">
                    {GooglePlayRating}
                  </Typography>
                  <StaticFourPointFiveStar />
                </ButtonBase>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Grid2>
    </Grid2>
  );
};

/**
 * Render a section with a brief abstract and link about Horde
 * as a company. In mobile view this will render as a white card section
 * */
const AboutHordeAbstract = () => {
  return (
    <Container
      component="section"
      sx={{ paddingY: { md: "80px", xs: "48px" } }}
    >
      <AbstractStackWithFigure />
    </Container>
  );
};
export default AboutHordeAbstract;
